import React from 'react';
import MpfUnidadeResponsavelBlockView, {
  type MpfUnidadeResponsavelBlockViewProps,
} from './View';

export interface MpfUnidadeResponsavelBlockEditProps
  extends MpfUnidadeResponsavelBlockViewProps {
  selected?: boolean;
  [key: string]: any;
}

/**
 * O bloco não tem nada a configurar: quem responde pela página é escolhido
 * no campo "Área responsável", na aba Propriedade do conteúdo, e o que
 * aparece de contato é decidido no cadastro da unidade
 * (`/unidades-responsaveis`). Aqui o editor só posiciona o card na coluna.
 *
 * Sem `SidebarPortal`, portanto — abrir um painel de ajustes vazio sugeriria
 * que existe algo a ajustar neste bloco.
 */
const MpfUnidadeResponsavelBlockEdit: React.FC<
  MpfUnidadeResponsavelBlockEditProps
> = (props) => <MpfUnidadeResponsavelBlockView {...props} isEditMode />;

export default MpfUnidadeResponsavelBlockEdit;
